import Api from '@/services/Api'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Iframe from '@/model/Iframe';
import Autenticacao from '@/model/Autenticacao';

const RECURSO = '/iframes'
const RECURSO_AUTH = '/autenticacoes'

export default {
  newIframe,
  getUrlIframe,
  getUrlIframeID,
  putIframe,
  postIframeRetornar,
  getAllIframes,
  deleteIframe,
  getIframeAuth,
  getAllIframesAuth,
  putIframeAuth,
  postIframeAuthRetornar,
  deleteIframeAuth,
  newAutenticacao
}

/**
 * Buscar uma url de iframe parametrizada nas ConstantesGlobais, no objeto LINK_IFRAME.
 * @param {string} nome - query que irá na url com o nome do dashboard solicitado
 * @return promise;
 *
 * @example
 *
 * getUrlIframe(ConstantesGlobais.LINK_IFRAME.ASSISTENCIA_SOCIAL.OCUPACAO_ABRIGOS)
 *
 */

function newIframe(id = 0, nome = "", url = "", dadosIntegracao = null, tipoIntegracao = "", iframeAutenticacao = null, privilegio = null){
  return new Iframe(id, nome,url,dadosIntegracao,tipoIntegracao,iframeAutenticacao, privilegio);
}

function getUrlIframe (nome) {
  return Api.get(`${RECURSO}/${nome.nome}`)
}
function getUrlIframeID (id) {
  return Api.get(`${RECURSO}/id/${MetodosGlobais.createEncodeQuery(id)}`)
}
function getAllIframes () {
  return Api.get(`${RECURSO}`)
}
function putIframe (payload) {
  return Api.put(`${RECURSO}/${payload.id}`, payload)
}
function postIframeRetornar (payload) {
  const param = { id: 0, nome: payload.nome, url: payload.url, dadosIntegracao: payload.dadosIntegracao, tipoIntegracao: payload.tipoIntegracao, 
    iframeAutenticacao: payload.iframeAutenticacao, privilegio: payload.privilegio }
  return Api.post(`${RECURSO}/retornar`, param)
}
function deleteIframe (id) {
  return Api.delete(`${RECURSO}/${id}`)
}

function newAutenticacao(id = 0, nomeAutenticacao = "", dadosAutenticacao = null){
  return new Autenticacao(id, nomeAutenticacao, dadosAutenticacao);
}

function getIframeAuth (nome) {
  return Api.get(`${RECURSO}${RECURSO_AUTH}/${nome.nome}`)
}
function getAllIframesAuth () {
  return Api.get(`${RECURSO}${RECURSO_AUTH}`)
}
function putIframeAuth (payload) {
  return Api.put(`${RECURSO}${RECURSO_AUTH}/${payload.id}`, payload)
}
function postIframeAuthRetornar (payload) {
  const param = { id: 0, nomeAutenticacao: payload.nomeAutenticacao, dadosAutenticacao: payload.dadosAutenticacao }
  return Api.post(`${RECURSO}${RECURSO_AUTH}/retornar`, param)
}
function deleteIframeAuth (id) {
  return Api.delete(`${RECURSO}${RECURSO_AUTH}/${id}`)
}
